export default "__VITE_PUBLIC_ASSET__5833747b__"